import { c as _c } from "react/compiler-runtime";
import { useIsMobile } from '@repo/ui/hooks';
import type { Column, DataTableFilterActions, FiltersState, FilterStrategy } from '../core';
import type { Locale } from '../lib/i18n';
import { ActiveFilters, ActiveFiltersMobileContainer } from './active-filters';
import { FilterSelector } from './filter-selector';
interface DataTableFilterProps<TData> {
  actions: DataTableFilterActions;
  columns: Column<TData>[];
  filters: FiltersState;
  locale?: Locale;
  strategy: FilterStrategy;
}
export function DataTableFilter(t0) {
  const $ = _c(21);
  const {
    actions,
    columns,
    filters,
    locale: t1,
    strategy
  } = t0;
  const locale = t1 === undefined ? "en" : t1;
  const isMobile = useIsMobile();
  if (isMobile) {
    let t2;
    if ($[0] !== actions || $[1] !== columns || $[2] !== filters || $[3] !== locale || $[4] !== strategy) {
      t2 = <div className="flex gap-1"><FilterSelector actions={actions} columns={columns} filters={filters} locale={locale} strategy={strategy} /></div>;
      $[0] = actions;
      $[1] = columns;
      $[2] = filters;
      $[3] = locale;
      $[4] = strategy;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== actions || $[7] !== columns || $[8] !== filters || $[9] !== locale || $[10] !== strategy) {
      t3 = <ActiveFiltersMobileContainer><ActiveFilters actions={actions} columns={columns} filters={filters} locale={locale} strategy={strategy} /></ActiveFiltersMobileContainer>;
      $[6] = actions;
      $[7] = columns;
      $[8] = filters;
      $[9] = locale;
      $[10] = strategy;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    let t4;
    if ($[12] !== t2 || $[13] !== t3) {
      t4 = <div className="flex w-full items-start justify-between gap-2">{t2}{t3}</div>;
      $[12] = t2;
      $[13] = t3;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    return t4;
  }
  let t2;
  if ($[15] !== actions || $[16] !== columns || $[17] !== filters || $[18] !== locale || $[19] !== strategy) {
    t2 = <div className="flex w-full items-start justify-between gap-2" data-sentry-component="DataTableFilter" data-sentry-source-file="data-table-filter.tsx"><div className="flex w-full flex-1 gap-2 md:flex-wrap"><FilterSelector actions={actions} columns={columns} filters={filters} locale={locale} strategy={strategy} data-sentry-element="FilterSelector" data-sentry-source-file="data-table-filter.tsx" /><ActiveFilters actions={actions} columns={columns} filters={filters} locale={locale} strategy={strategy} data-sentry-element="ActiveFilters" data-sentry-source-file="data-table-filter.tsx" /></div></div>;
    $[15] = actions;
    $[16] = columns;
    $[17] = filters;
    $[18] = locale;
    $[19] = strategy;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  return t2;
}